import { GtagItemType } from "@shared/lib/analytics/types/analytics-types";
import Box from "@ui-kit/layout/Box/Box.web";
import { useCharity } from "@shared/modules/events/components/donations/hooks/useCharity";
import useItemGroupEvent from "../hooks/useItemGroupEvent";
import type { BaseItemGroupDisplayProps } from "../ItemGroup.props";
import ItemGroupDisplay from "../ItemGroupDisplay/ItemGroupDisplay.web";
import ItemGroupSkeleton from "../ItemGroupSkeleton/ItemGroupSkeleton.web";

export default function ItemGroupDonation({
  eventId,
  quantity,
  ticketTypeId,
  isParentLoading = false,
  updateItemTracking,
  eventService,
  isDonation,
  ...rest
}: {
  eventId: number;
  quantity: number;
  isDonation: boolean;
  ticketTypeId: number | undefined;
  updateItemTracking: ((input: GtagItemType) => void) | undefined;
  isParentLoading: boolean | undefined;
} & Omit<BaseItemGroupDisplayProps, "name">): JSX.Element {
  const { eventData, isFetching } = useItemGroupEvent(
    eventId,
    ticketTypeId,
    eventService,
    updateItemTracking
  );

  const { cause, isLoading } = useCharity(
    eventData?.charities_of_choice?.[eventData.charities_of_choice.length - 1],
    eventData
  );
  const showSkeleton = isFetching || isParentLoading || isLoading;
  return (
    <Box width="100%">
      {showSkeleton && <ItemGroupDonation.Skeleton />}
      {!showSkeleton && eventData && (
        <ItemGroupDisplay
          eventService={eventService}
          {...rest}
          name={cause?.name || ""}
          quantity={quantity}
          isDonation={isDonation}
        />
      )}
    </Box>
  );
}

ItemGroupDonation.Skeleton = ItemGroupSkeleton;
